module.exports = __webpack_public_path__ + "img/133-39ccd1.png";